/*!

=========================================================
* Vue Light Bootstrap Dashboard - v1.3.1
=========================================================

* Product Page: http://www.creative-tim.com/product/vue-light-bootstrap-dashboard-pro
* Copyright 2019 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import LightBootstrap from './light-bootstrap-main'

// Plugins
import App from './App.vue'
import store from './store'
import seApi from 'src/util/seapi'

import IconBase from '@/components/IconBase.vue'
import { getInstance } from 'recaptcha-v3'

// router setup
import routes from './routes/routes'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Filters (Vue 3: use globalProperties.$filters instead of Vue.filter)
import {
  toCurPercent,
  toCurDecimal,
  toCurrency,
  toPercent,
  toDate,
  toDateTime
} from './util/filters'

if (process.env.NODE_ENV === "development") {
  console.log("devMode");
  import('@vue/devtools').then(({ devtools }) => {
    devtools.connect("http://localhost", 8098).catch(e => console.error(e));
  });
}

// configure router
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: 'active',
  scrollBehavior() {
    return { left: 0, top: 0, behavior: 'smooth' }
  }
})

const onRouterError = (e) => {
  // avoid NavigationDuplicated
  if (e.name !== 'NavigationDuplicated') throw e
}

router.beforeEach((to, from, next) => {
  let r = getInstance()
  if (r) {
    if (to.path === '/se-eval/eval-findings') {
      r.hideBadge()
    } else {
      r.showBadge()
    }
  }

  try {
    if (!store.state.se.accessAllowed && to.name !== 'Welcome') {
      next('/home/welcome')
    } else {
      next()
    }
  } catch (e) {
    onRouterError(e)
  }
})

seApi.setEnv();

const app = createApp(App);

// Register global components
app.component('icon-base', IconBase);

// Register global filters as properties (Vue 3 replacement for Vue.filter)
app.config.globalProperties.$filters = {
  toCurPercent,
  toCurDecimal,
  toCurrency,
  toPercent,
  toDate,
  toDateTime
}

app.use(router);
app.use(store);
app.use(LightBootstrap);
app.use(ElementPlus);


app.mount('#app');

/* eslint-disable no-new */
